import s from '../../components/Preloader/Preloader.module.scss';

export const FuelCanisterIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1280" className={s.gradient_animation}>
            <defs>
                <linearGradient id="bgGradient" x1="0" x2="0" y1="1" y2="0">
                    <stop offset="0%" stopColor="#DF3B00"/>
                    <stop offset="100%" stopColor="#FFFFFF"/>
                </linearGradient>
            </defs>

            <g stroke="black" strokeWidth="15" fill="url(#bgGradient)">
                <path
                    d="M846.78,243.5H800h-3.09H607.31c-23.68,0-45.95,12.61-58.13,32.91l-28.25,47.09h-16.34c-4.98,0-9.83,0.93-14.37,2.72
                    l-24.14-33.27c-4.06-5.59-10.05-9.27-16.88-10.36c-4.96-0.79-9.92-0.13-14.41,1.84l-51.17-74.49c-0.06-0.09-0.12-0.17-0.18-0.26
                    c-10.23-14.11-24.23-24.86-40.5-31.08l-162.46-62.26c-3.84-1.48-8.16-0.96-11.56,1.37c-3.39,2.33-5.42,6.18-5.42,10.3v28.18
                    c0,4.2,2.11,8.12,5.62,10.43l124.8,82.31l63.4,91.51c-3.56,3.75-5.91,8.48-6.75,13.71c-1.09,6.83,0.55,13.67,4.61,19.26l24,33.07
                    c-4.92,6.68-7.69,14.83-7.69,23.31v417c0,34.03,27.69,61.72,61.72,61.72h413.56c34.03,0,61.72-27.69,61.72-61.72V305.22
                    C908.5,271.19,880.81,243.5,846.78,243.5z"
                />
            </g>

            <path fill={'#DF3B00'}
                  d="M193.42,439.79c-2.37-2.72-5.81-4.29-9.42-4.29c0,0-0.01,0-0.01,0c-3.62,0-7.06,1.57-9.43,4.31
                    c-0.59,0.68-14.72,17.02-29.02,38.88c-19.93,30.47-30.04,56.03-30.04,75.98c0,36.3,30.73,65.83,68.5,65.83s68.5-29.53,68.5-65.83
                    c0-20.05-10.11-45.65-30.04-76.08C208.15,456.76,194.02,440.47,193.42,439.79z"
            />

            <path
                d="M808.84,456.84l-17.68-17.68l-60.34,60.34H549.18l-60.34-60.34l-17.68,17.68l60.34,60.34v197.64l-60.34,60.34l17.68,17.68
                    l60.34-60.34h181.64l60.34,60.34l17.68-17.68l-60.34-60.34V517.18L808.84,456.84z M723.5,707.5h-167v-183h167V707.5z"
            />
        </svg>
    );
};


/*values="1; 0; 1"*/


/*
export const FuelCanisterIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1280">
            <defs>
                <linearGradient id="bgGradient" x1="0" x2="0" y1="1" y2="0">
                    <stop offset="0%" stopColor="#DF3B00">
                        <animate attributeName="offset" values="1; 0" dur="2s" repeatCount="indefinite"/>
                    </stop>
                    <stop offset="0%" stopColor="#FFFFFF">
                        <animate attributeName="offset" values="1; 0" dur="2s" repeatCount="indefinite"/>
                    </stop>
                </linearGradient>
            </defs>

            <g stroke="black" strokeWidth="15" fill="url(#bgGradient)">
                <path
                    d="M846.78,243.5H800h-3.09H607.31c-23.68,0-45.95,12.61-58.13,32.91l-28.25,47.09h-16.34c-4.98,0-9.83,0.93-14.37,2.72
                    l-24.14-33.27c-4.06-5.59-10.05-9.27-16.88-10.36c-4.96-0.79-9.92-0.13-14.41,1.84l-51.17-74.49c-0.06-0.09-0.12-0.17-0.18-0.26
                    c-10.23-14.11-24.23-24.86-40.5-31.08l-162.46-62.26c-3.84-1.48-8.16-0.96-11.56,1.37c-3.39,2.33-5.42,6.18-5.42,10.3v28.18
                    c0,4.2,2.11,8.12,5.62,10.43l124.8,82.31l63.4,91.51c-3.56,3.75-5.91,8.48-6.75,13.71c-1.09,6.83,0.55,13.67,4.61,19.26l24,33.07
                    c-4.92,6.68-7.69,14.83-7.69,23.31v417c0,34.03,27.69,61.72,61.72,61.72h413.56c34.03,0,61.72-27.69,61.72-61.72V305.22
                    C908.5,271.19,880.81,243.5,846.78,243.5z"
                />
            </g>

            <path fill={'#DF3B00'}
                  d="M193.42,439.79c-2.37-2.72-5.81-4.29-9.42-4.29c0,0-0.01,0-0.01,0c-3.62,0-7.06,1.57-9.43,4.31
                    c-0.59,0.68-14.72,17.02-29.02,38.88c-19.93,30.47-30.04,56.03-30.04,75.98c0,36.3,30.73,65.83,68.5,65.83s68.5-29.53,68.5-65.83
                    c0-20.05-10.11-45.65-30.04-76.08C208.15,456.76,194.02,440.47,193.42,439.79z"
            />

            <path
                d="M808.84,456.84l-17.68-17.68l-60.34,60.34H549.18l-60.34-60.34l-17.68,17.68l60.34,60.34v197.64l-60.34,60.34l17.68,17.68
                    l60.34-60.34h181.64l60.34,60.34l17.68-17.68l-60.34-60.34V517.18L808.84,456.84z M723.5,707.5h-167v-183h167V707.5z"
            />
        </svg>
    );
};*/